import {useState} from "react";
import SystemLeaveFlashDialog from "../../../components/dialogs/SystemLeaveFlashDialog";
import {isArrayNullUndefinedOrEmpty} from "../../../services/Validator";
import SystemExistingFlashSnackBar from "../../../components/snackbars/SystemExistingFlashSnackBar";
import {useResizeListener} from "../../../listeners/SystemResizeListener";
import SystemFullScreenError from "../../../components/errors/SystemFullScreenError";
import FlashResultsScreen from "./FlashResultsScreen";
import FlashTabletTopBar from "../../../components/bars/courses/flash/FlashTabletTopBar";
import FlashDesktopTopBar from "../../../components/bars/courses/flash/FlashDesktopTopBar";
import FlashTabletBottomBar from "../../../components/bars/courses/flash/FlashTabletBottomBar";
import FlashDesktopBottomBar from "../../../components/bars/courses/flash/FlashDesktopBottomBar";
import FlashQuestionContent from "../../../components/others/courses/flash/FlashQuestionContent";
import FlashQuestionTabletLayout from "../../../components/layouts/courses/flash/FlashQuestionTabletLayout";
import FlashQuestionDesktopLayout from "../../../components/layouts/courses/flash/FlashQuestionDesktopLayout";
import FlashQuestionDontKnowDialog from "../../../components/dialogs/courses/flash/FlashQuestionDontKnowDialog";

export default function MetaFlashScreen({ selectedGrade,
                                          questions,
                                          questionIndex,
                                          selectedOption,
                                          setSelectedOption,
                                          submitAnswer,
                                          onLeaveFlashPressed,
                                          setIsLeaveModalOpen,
                                          isLeaveModalOpen,
                                          leaveSessionCallback,
                                          isSnackbarOpen,
                                          handleClose,
                                          isFlashOver }) {
    // Used in MetaCoursesScreen Component to display series of questions

    // PROPERTIES
    // ---- Meta
    const [openDontKnowDialog, setOpenDontKnowDialog] = useState(false)
    const totalQuestions = questions?.length
    const currentQuestionIndex = questionIndex + 1

    // HOOKS
    // ---- Eventually close modal during screen resize
    useResizeListener(() => setOpenDontKnowDialog(false))

    // BUILD
    if (isArrayNullUndefinedOrEmpty(questions))
        return <SystemFullScreenError />
    if (isFlashOver)
        return <FlashResultsScreen selectedGrade={selectedGrade}
                                   questions={questions}
                                   isLeaveModalOpen={isLeaveModalOpen}
                                   setIsLeaveModalOpen={setIsLeaveModalOpen}
                                   onLeaveFlashPressed={onLeaveFlashPressed}
                                   leaveFlash={leaveSessionCallback}
                                   isSnackbarOpen={isSnackbarOpen}
                                   handleClose={handleClose}/>
    return(
        <div className="overflow-auto animate-appear w-full h-[100svh] bg-backgroundLight3 flex flex-col items-center justify-start">
            {/** ---- SNACKBAR */}
            <SystemExistingFlashSnackBar open={isSnackbarOpen}
                                       handleClose={handleClose} />
            {/** ---- MODAL */}
            <SystemLeaveFlashDialog open={isLeaveModalOpen}
                                    handleClose={() => setIsLeaveModalOpen(false)}
                                    leave={leaveSessionCallback} />
            <FlashQuestionDontKnowDialog open={openDontKnowDialog}
                                         handleClose={() => setOpenDontKnowDialog(false)} />
            {/** TOP BAR */}
            <FlashTabletTopBar onLeaveFlashPressed={onLeaveFlashPressed}
                               selectedGrade={selectedGrade}
                               currentQuestion={currentQuestionIndex}
                               totalQuestion={totalQuestions} />
            <FlashDesktopTopBar onLeaveFlashPressed={onLeaveFlashPressed}
                                selectedGrade={selectedGrade}
                                currentQuestion={currentQuestionIndex}
                                totalQuestion={totalQuestions} />
            {/** CONTENT */}
            <div className={"overflow-auto bg-backgroundLight3 w-full grow flex flex-col items-center"}>
              {/** ---- TABLET */}
              <FlashQuestionTabletLayout>
                  <FlashQuestionContent question={questions[questionIndex]}
                                        optionSelected={selectedOption}
                                        setOptionSelected={setSelectedOption}
                                        setOpenDontKnowDialog={setOpenDontKnowDialog} />
                  <FlashTabletBottomBar selectedOption={selectedOption}
                                        submitAnswer={submitAnswer} />
              </FlashQuestionTabletLayout>
              {/** ---- DESKTOP */}
              <FlashQuestionDesktopLayout>
                  <FlashQuestionContent question={questions[questionIndex]}
                                        optionSelected={selectedOption}
                                        setOptionSelected={setSelectedOption}
                                        setOpenDontKnowDialog={setOpenDontKnowDialog} />
                  <FlashDesktopBottomBar selectedOption={selectedOption}
                                         submitAnswer={submitAnswer} />
              </FlashQuestionDesktopLayout>
            </div>
        </div>
    );
}